import * as d3 from "d3";
import * as topojson from "topojson-client";
import world from "world-atlas/countries-110m.json";

window.d3 = d3;
window.world = world;
window.topojson = topojson;
